import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Avatar,
  Divider,
} from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts"; // Import recharts components here
import TractorIcon from "@mui/icons-material/Agriculture";
import UserIcon from "@mui/icons-material/Person";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

const Dashboard = () => {
  const overviewData = {
    totalMachines: "560K",
    totalUsers: "590K",
    appliedSubsidies: "520K",
    areaWiseSubsidy: [
      { name: "Barnala", popularity: 0.45, percentage: "45%" },
      { name: "Mohali", popularity: 0.29, percentage: "29%" },
      { name: "Amritsar", popularity: 0.18, percentage: "18%" },
      { name: "Tarn Taran", popularity: 0.25, percentage: "25%" },
    ],
    categoryWiseSubsidy: [
      { category: "OBC", value: 22000000 },
      { category: "ST", value: 20000000 },
      { category: "SC", value: 21000000 },
      { category: "MEN", value: 23000000 },
      { category: "GEN", value: 14000000 },
      { category: "WOMEN", value: 25000000 },
    ],
    topSellingMachinesCurrentMonth: [
      { name: "Seeder", value: 85 },
      { name: "Plough", value: 30 },
      { name: "Leveler", value: 15 },
      { name: "Harvester", value: 22 },
    ],
    usersByScheme: [
      { scheme: "PMKY", users: 192 },
      { scheme: "KVY", users: 64 },
      { scheme: "RKVY", users: 11 },
      { scheme: "PMKSY", users: 8 },
    ],
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center" mb={1}>
              <Avatar sx={{ mr: 1, bgcolor: "#ffe0b2" }}>
                <TractorIcon sx={{ color: "#ff9800" }} />
              </Avatar>
              <Typography variant="h6">Total Machines</Typography>
            </Box>
            <Typography variant="h4">{overviewData.totalMachines}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={4}>
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center" mb={1}>
              <Avatar sx={{ mr: 1, bgcolor: "#c8e6c9" }}>
                <UserIcon sx={{ color: "#4caf50" }} />
              </Avatar>
              <Typography variant="h6">Total Users</Typography>
            </Box>
            <Typography variant="h4">{overviewData.totalUsers}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={4}>
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center" mb={1}>
              <Avatar sx={{ mr: 1, bgcolor: "#e1bee7" }}>
                <LocalOfferIcon sx={{ color: "#9c27b0" }} />
              </Avatar>
              <Typography variant="h6">Applied Subsidies</Typography>
            </Box>
            <Typography variant="h4">
              {overviewData.appliedSubsidies}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Area wise Subsidy
            </Typography>
            <List>
              {overviewData.areaWiseSubsidy.map((item, index) => (
                <ListItem key={index}>
                  <ListItemText primary={`${index + 1}. ${item.name}`} />
                  <Box
                    sx={{ display: "flex", alignItems: "center", width: "60%" }}
                  >
                    <LinearProgress
                      variant="determinate"
                      value={item.popularity * 100}
                      sx={{ mr: 1, flexGrow: 1 }}
                    />
                    <Typography variant="body2">{item.percentage}</Typography>
                  </Box>
                </ListItem>
              ))}
            </List>
          </CardContent>
        </Card>
      </Grid>

      {/* <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Category wise Subsidy
            </Typography>
            <ResponsiveContainer height={250}>
              <BarChart data={overviewData.categoryWiseSubsidy}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="category" />
                <YAxis tickFormatter={(value) => `${value / 1000000}M`} />
                <Bar dataKey="value" fill="#8884d8" />
              </BarChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </Grid> */}

      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Top Selling Machines (Current Month - April)
            </Typography>
            <List>
              {overviewData.topSellingMachinesCurrentMonth.map((item) => (
                <ListItem key={item.name}>
                  <ListItemText primary={item.name} />
                  <Box
                    sx={{ display: "flex", alignItems: "center", width: "60%" }}
                  >
                    <LinearProgress
                      variant="determinate"
                      value={item.value}
                      sx={{ mr: 1, flexGrow: 1 }}
                    />
                    <Typography variant="body2">{item.value}</Typography>
                  </Box>
                </ListItem>
              ))}
            </List>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Users by Scheme
            </Typography>
            <List>
              {overviewData.usersByScheme.map((item) => (
                <ListItem key={item.scheme}>
                  <ListItemText primary={item.scheme} />
                  <Box
                    sx={{ display: "flex", alignItems: "center", width: "40%" }}
                  >
                    <LinearProgress
                      variant="determinate"
                      value={
                        (item.users /
                          Math.max(
                            ...overviewData.usersByScheme.map((s) => s.users)
                          )) *
                        100
                      }
                      sx={{ mr: 1, flexGrow: 1 }}
                    />
                    <Typography variant="body2">{item.users}</Typography>
                  </Box>
                </ListItem>
              ))}
            </List>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
